<template>
  <PurchaseHeader>
    <SupplierTable/>
  </PurchaseHeader>
</template>

<script>
import PurchaseHeader from "@/purchase/components/PurchaseHeader.vue";
import SupplierTable from "@/purchase/components/tables/SupplierTable.vue";

export default {
  name: 'SupplierView',
  components: {PurchaseHeader, SupplierTable}
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

h1
  color THEME_COLOR_PRIMARY

  span
    color THEME_COLOR_PRIMARY_FADDED
</style>
